import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "@saleor/types";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

const permissionGroupSection = "/permission-groups/";

export const permissionGroupListPath = permissionGroupSection;

export type PermissionGroupListUrlDialog = "remove" | TabActionDialog;
export enum PermissionGroupListUrlSortField {
  name = "name"
}

export enum PermissionGroupListUrlFiltersEnum {
  query = "query"
}
export type PermissionGroupListUrlFilters = Filters<
  PermissionGroupListUrlFiltersEnum
>;
export type PermissionGroupListUrlSort = Sort<PermissionGroupListUrlSortField>;
export type PermissionGroupListUrlQueryParams = Dialog<
  PermissionGroupListUrlDialog
> &
  ActiveTab &
  Pagination &
  PermissionGroupListUrlSort &
  SingleAction &
  PermissionGroupListUrlFilters;
export const permissionGroupListUrl = (
  params?: PermissionGroupListUrlQueryParams
) => permissionGroupListPath + "?" + stringifyQs(params);

export const permissionGroupAddPath = urlJoin(permissionGroupSection, "add");
export const permissionGroupAddUrl = permissionGroupAddPath;

export const permissionGroupMultiFactorAuthenticationPath = urlJoin(
  permissionGroupSection,
  "multi-factor-authentication"
);
export const permissionGroupMultiFactorAuthenticationUrl = permissionGroupMultiFactorAuthenticationPath;

export enum MembersListUrlSortField {
  name = "name",
  email = "email"
}
export type MembersListUrlSort = Sort<MembersListUrlSortField>;

export const permissionGroupDetailsPath = (id: string) =>
  urlJoin(permissionGroupSection, id);
export type PermissionGroupDetailsUrlDialog =
  | "remove"
  | "assign"
  | "unassign"
  | "unassignError";
export type PermissionGroupDetailsUrlQueryParams = BulkAction &
  Pagination &
  MembersListUrlSort &
  Dialog<PermissionGroupDetailsUrlDialog>;

export const permissionGroupDetailsUrl = (
  id: string,
  params?: PermissionGroupDetailsUrlQueryParams
) =>
  permissionGroupDetailsPath(encodeURIComponent(id)) +
  "?" +
  stringifyQs(params);
